module.exports = {"Operate11":{"daobanList":[{"title":"1:您是企业办理建设项目环境影响报告表审批还是个人办理建设项目环境影响报告表审批？","values":[{"name":"是","xuanzhong":1,"cailiaoList":[{"name":"1、排污许可证申请表","state":"必要"},{"name":"2、承诺书","state":"必要"},{"name":"3、自行监测方案","state":"必要"},{"name":"4、排污许可证申领信息公开情况说明表","state":"非必要"},{"name":"5、重点污染物排放总量控制指标的说明材料","state":"非必要"}]},{"name":"否","xuanzhong":0,"cailiaoList":[]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/sdo-11.json
// module id = 1268
// module chunks = 0